import { useDebouncedValue } from './useDebouncedValue.js';

// <input type="date"> fires onChange on every keystroke, so typing a year
// walks through absurd partial values (0002 → 0020 → 0202 → 2026). Sending
// those to the API spammed the backend and 500'd (years < 1753 are out of SQL
// Server's datetime range). A date is only "effective" once it's complete and
// in a sane window; until then it's treated as unset so no half-date is sent.
const sane = (d) =>
  (/^\d{4}-\d{2}-\d{2}$/.test(d) && +d.slice(0, 4) >= 2000 && +d.slice(0, 4) <= 2100)
    ? d : '';

// Returns [effDateStart, effDateEnd] — the committed date range validated and
// debounced as a *pair* (one timer keyed on both), so committing Date From
// then Date To back-to-back settles into a single fetch instead of two. The
// inputs commit on blur (see RecordsFilters / PushQueuePanel), so nothing
// fires while the user is still editing a date; this just coalesces the
// From-blur + To-blur into one request.
export function useEffectiveDateRange(dateStart, dateEnd, delay = 350) {
  const key = `${dateStart || ''}|${dateEnd || ''}`;
  const debounced = useDebouncedValue(key, delay);
  const [ds = '', de = ''] = debounced.split('|');
  return [sane(ds), sane(de)];
}
